import axios from "axios";

const hostname = typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();
const sameSiteApiByHost = {
  "submit.dancingwithher.com": "https://api.dancingwithher.com",
  "submit.dancingwiththem.com": "https://api.dancingwiththem.com",
};
const BACKEND_URL = sameSiteApiByHost[hostname] || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Submitter (magic-link) session token helpers
export const getSubmitterToken = () => localStorage.getItem("btl_session") || "";
export const setSubmitterToken = (t) => localStorage.setItem("btl_session", t);
export const clearSubmitterToken = () => localStorage.removeItem("btl_session");

const submissionAccessKey = (eventId) => `btl_submission_access:${eventId}`;
const submissionAccessMemory = new Map();
export const setSubmissionAccessToken = (eventId, token) => {
  if (!eventId || !token) return;
  submissionAccessMemory.set(eventId, token);
  try {
    sessionStorage.setItem(submissionAccessKey(eventId), token);
  } catch {
    // Keep submission navigation working when browser storage is unavailable.
  }
};

const getSubmissionAccessToken = (eventId) => {
  try {
    return sessionStorage.getItem(submissionAccessKey(eventId)) ||
      submissionAccessMemory.get(eventId) || "";
  } catch {
    return submissionAccessMemory.get(eventId) || "";
  }
};

// Attach the submitter session to non-admin calls (admin uses cookie auth)
api.interceptors.request.use((config) => {
  const t = getSubmitterToken();
  const url = config.url || "";
  if (t && !url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  if (!url.startsWith("/admin")) {
    const eventMatch = url.match(/(?:^|\/)events\/([^/?#]+)/);
    if (eventMatch) {
      const eventId = decodeURIComponent(eventMatch[1]);
      const accessToken = getSubmissionAccessToken(eventId);
      if (accessToken) {
        config.headers = config.headers || {};
        config.headers["X-Submission-Access"] = accessToken;
      }
    }
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatApiError(error, fallback = "We couldn't complete this step.") {
  const detail = error?.response?.data?.detail;
  if (detail != null && detail !== "") return formatApiErrorDetail(detail);
  if (!error?.response) {
    return "We couldn't reach the server, so we can't confirm whether this step saved. Check your connection and try again.";
  }
  const status = error.response.status;
  if (status === 401 || status === 403) {
    return "Your sign-in or submission link may have expired. Sign in again and continue from My submissions.";
  }
  return `${fallback} Please try again. (Error ${status})`;
}
